import {Reducer} from "redux";
import { ClientPmCampaignAction, ClientPmCampaignActionType, ICallbackGetCustomerByClientPmCampaignPageAction} from "../action/client_pm_campaign";
import { ClientPmCampaignState } from "../store/client_pm_campaign_store";

const initialState: ClientPmCampaignState = {
    pmCustomers: [],
    toBPmCustomers: [],
    toCPmCustomers: [],
    bizdevPmCustomers: [],
    growthPmCustomers: [],
    pmmCustomers: [],
    poCustomers: [],
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
};

const clientPmCampaignReducer: Reducer<ClientPmCampaignState> = (state = initialState, action: ClientPmCampaignAction): ClientPmCampaignState => {
    switch (action.type) {

        case ClientPmCampaignActionType.REQUEST_GET_CUSTOMERS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientPmCampaignActionType.CALLBACK_GET_CUSTOMERS: {
            const _action = action as ICallbackGetCustomerByClientPmCampaignPageAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    pmCustomers: (_action.item) ? _action.item.pmCustomers : [],
                    toBPmCustomers: (_action.item) ? _action.item.toBPmCustomers : [],
                    toCPmCustomers: (_action.item) ? _action.item.toCPmCustomers : [],
                    bizdevPmCustomers: (_action.item) ? _action.item.bizdevPmCustomers : [],
                    growthPmCustomers: (_action.item) ? _action.item.growthPmCustomers : [],
                    pmmCustomers: (_action.item) ? _action.item.pmmCustomers : [],
                    poCustomers: (_action.item) ? _action.item.poCustomers : [],
                    jobCareersWithCustomerID: (_action.item) ? _action.item.jobCareersWithCustomerID : [],
                    clientBookmarks: (_action.item) ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientPmCampaignReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_pm_campaign_reducer.ts